export const usersCollectionName = 'Users';
export const usersEnglishWordsCollectionName = 'English_Words';
export const contactCollectionName = 'Contacts';
